<template>
  <section class="mobile-images">
    <!-- 홍보 이미지들 + home2 승인 섹션 + home4 평형 탭 -->
    <template v-for="(image, index) in images" :key="index">
      <div class="image-wrapper">
        <img
          :src="image.src"
          :alt="`홍보 이미지 ${index + 1}`"
          loading="lazy"
        />
      </div>
      <MobileApproval v-if="image.name === 'home2'" />
      <MobileUnitTab v-if="image.name === 'home4'" />
    </template>

    <!-- 마지막 CTA 배너 -->
    <div class="cta-banner" @click="$emit('open-form')">
      <div class="cta-content">
        <span class="cta-badge">CONTACT</span>
        <h3 class="cta-title">지금 바로 상담받기</h3>
        <p class="cta-desc">연락처를 남겨주시면<br>담당자가 빠르게 연락드립니다</p>
        <div class="cta-btn">
          <span>상담 신청</span>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MobileUnitTab from '@/components/mobile/MobileUnitTab.vue'
import MobileApproval from '@/components/mobile/MobileApproval.vue'

export default {
  name: 'MobileImageSection',
  components: {
    MobileUnitTab,
    MobileApproval
  },
  emits: ['open-form'],
  data() {
    return {
      images: []
    }
  },
  created() {
    // assets 폴더에서 이미지 로드 (이름 포함)
    for (let i = 1; i <= 11; i++) {
      try {
        const src = require(`@/assets/mobile/home${i}.jpg`)
        this.images.push({ src, name: `home${i}` })
      } catch (e) {
        // 해당 번호의 이미지 없음
      }
    }
  }
}
</script>

<style scoped>
.mobile-images {
  width: 100%;
}

.image-wrapper {
  width: 100%;
  line-height: 0;
}

.image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

/* CTA 배너 */
.cta-banner {
  width: 100%;
  padding: 50px 24px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.cta-banner::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(0, 171, 205, 0.1) 0%, transparent 60%);
  animation: pulse-bg 4s ease-in-out infinite;
}

@keyframes pulse-bg {
  0%, 100% { transform: scale(1); opacity: 0.5; }
  50% { transform: scale(1.1); opacity: 1; }
}

.cta-content {
  position: relative;
  z-index: 2;
  text-align: center;
}

.cta-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: var(--main-color1);
  margin-bottom: 16px;
}

.cta-title {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.cta-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.6;
  margin-bottom: 28px;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  background: var(--main-color1);
  color: #fff;
  border-radius: 30px;
  font-size: 15px;
  font-weight: 600;
  transition: all 0.3s;
}

.cta-btn svg {
  width: 18px;
  height: 18px;
  transition: transform 0.3s;
}

.cta-banner:active .cta-btn {
  transform: scale(0.95);
}

.cta-banner:active .cta-btn svg {
  transform: translateX(4px);
}
</style>